import api from "@/lib/axios";

export const notificationService = {
    getNotifications: async (params = {}) => {
        try {
            const response = await api.get("/notifications", { params });
            return response.data;
        } catch (error) {
            if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw new Error("Failed to fetch notifications: " + error.message);
        }
    },

    markAsRead: async (notificationId) => {
        try {
            const response = await api.put(`/notifications/${notificationId}/read`);
            return response.data;
        } catch (error) {
            if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw new Error("Failed to mark notification as read: " + error.message);
        }
    },

    markAllAsRead: async () => {
        try {
            const response = await api.put("/notifications/read-all-notifications");
            return response.data;
        } catch (error) {
            if (error.response?.data?.message) {
                throw new Error(error.response.data.message);
            }
            throw new Error("Failed to mark all notifications as read: " + error.message);
        }
    }
};
